module.exports = __webpack_public_path__ + "img/moonchild.6c84161e.png";